import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import Layout from './components/common/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Chat from './pages/Chat'
import ConversationsPage from './pages/ConversationsPage'
import Profile from './pages/Profile'
import Health from './pages/Health'
import Faces from './pages/Faces'
import Events from './pages/Events'
import Notifications from './pages/Notifications'
import JournalChat from './components/JournalChat'
import JournalHistory from './components/JournalHistory'
import Journal from './pages/Journal'
import LoadingSpinner from './components/common/LoadingSpinner'
import HealthOnboardingWrapper from './components/HealthOnboardingWrapper'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={
          !user ? <Login /> : <Navigate to="/dashboard" />
        } />
        <Route path="/register" element={
          !user ? <Register /> : <Navigate to="/dashboard" />
        } />
        
        {/* Protected routes */}
        <Route path="/" element={
          user ? (
            <HealthOnboardingWrapper>
              <Layout />
            </HealthOnboardingWrapper>
          ) : <Navigate to="/login" />
        }>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="chat" element={<Chat />} />
          <Route path="chat/all" element={<ConversationsPage />} />
          <Route path="chat/:conversationId" element={<Chat />} />
          <Route path="health" element={<Health />} />
          <Route path="faces" element={<Faces />} />
          <Route path="events" element={<Events />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="journal" element={<Journal />} />
          <Route path="journal/write" element={<JournalChat />} />
          <Route path="journal/history" element={<JournalHistory />} />
          <Route path="profile" element={<Profile />} />
        </Route>
        
        {/* Catch all */}
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
      </Routes>
    </div>
  )
}

export default App
